import React, { useEffect } from "react";
import { Form, Input, Select } from "antd";
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import {
  getTrainingModuleResultDetails,
  doTrainingModuleResultCreate,
  doTrainingModuleResultUpdate,
} from "../../../../../redux/trainingclass/trainingClassState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";

const TrainingModuleResultForm = ({
  doCreate,
  doUpdate,
  onCancel,
  recordData,
  classeId,
  getDetails,
  submitLabel,
  ...props
}) => {
  const [form] = Form.useForm();
  const { recordId, mode } = props;

  useEffect(() => {
    if (recordData) {
      form.resetFields();

      const initialValues = {
        ...recordData,
        trs_class_id: classeId,
      };

      form.setFieldsValue(initialValues);
    }
  }, [recordData, classeId, form]);

  useEffect(() => {
    if (classeId && recordId === 0) {
      getDetails({ classeId, resultId: 0 });
    } else if (classeId && recordId) {
      getDetails({ classeId, resultId: recordId });
    }
  }, [classeId, recordId, getDetails]);

  const onSubmit = (formData) => {
    try {
      formData.trs_class_id = classeId;

      recordData?.trs_id > 0 ? doUpdate(formData) : doCreate(formData);
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
      className={mode !== "view" ? "form" : ""}
    >
      <FormItem name="trs_id" hidden>
        <Input type="hidden" />
      </FormItem>

      <div className="col-span-3">
        <FormItem
          name="trs_score"
          label="Result Score"
          rules={[requiredField]}
        >
          {mode !== "view" ? (
            <Input placeholder="Enter result score" />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.trs_score}
            </label>
          )}
        </FormItem>
      </div>

      <div className="col-span-3">
        <FormItem
          name="trs_status"
          label="Result Status"
          rules={[requiredField]}
        >
          {mode !== "view" ? (
            <Select
              id="trs_status"
              placeholder="Select status"
              allowClear
              options={[
                { label: "Passed", value: "Passed" },
                { label: "Failed", value: "Failed" },
                { label: "In Progress", value: "In Progress" },
              ]}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.trs_status}
            </label>
          )}
        </FormItem>
      </div>

      {mode === "edit" && (
        <div className="w-full flex justify-end">
          <CrudButtons
            mode={mode}
            recordId={recordData?.trs_id ?? 0}
            isModal={true}
            allowEdit={false}
            modalId={
              recordData?.trs_id > 0
                ? "edit_training_module_result"
                : "add_training_module_result"
            }
            cancelLabel="Cancel"
            doHideModal={onCancel}
            submitLabel={submitLabel}
          />
        </div>
      )}
    </Form>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.trainingClass.trainingModuleResultDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getDetails: (data) => dispatch(getTrainingModuleResultDetails(data)),
  doCreate: (data) => dispatch(doTrainingModuleResultCreate(data)),
  doUpdate: (data) => dispatch(doTrainingModuleResultUpdate(data)),
});

export default connect(mapStateToProps,mapDispatchToProps)(TrainingModuleResultForm);
